import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AiProductCardProps {
  product: {
    id: string;
    slug: string;
    name: string;
    price: number;
    compareAtPrice?: number | null;
    image?: string | null;
    rating?: number | null;
  };
}

export const AiProductCard: React.FC<AiProductCardProps> = ({ product }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('shop');

  return (
    <div 
      onClick={() => navigate(`/product/${product.slug}`)}
      className="flex-none w-48 bg-white border border-secondary rounded-xl overflow-hidden shadow-sm cursor-pointer hover:shadow-md transition-shadow group snap-center"
    >
      <div className="relative aspect-square bg-background">
        {product.image ? (
          <img 
            src={`/uploads/${product.image}`} 
            alt={product.name} 
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-text-muted">
            {t('aiChat.noImage', 'No Image')}
          </div>
        )}
      </div>
      <div className="p-3">
        <h4 className="text-sm font-semibold text-text-main line-clamp-2 min-h-[40px] mb-1">
          {product.name}
        </h4>
        
        <div className="flex items-center gap-1 mb-2">
          {product.rating ? (
            <>
              <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
              <span className="text-xs font-medium text-text-main">{product.rating.toFixed(1)}</span>
            </>
          ) : null}
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-bold text-primary">
            EGP {product.price.toLocaleString()}
          </span>
          {product.compareAtPrice && product.compareAtPrice > product.price && (
            <span className="text-xs text-text-muted line-through">
              EGP {product.compareAtPrice.toLocaleString()}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
